import './Footer.css';
import { Link } from 'react-router-dom';
import translations from '../components/ComponentsTranslations.lang.json';
import { useLanguage } from '../utils/LanguageContext';
import { Space } from 'antd';
import { useClientParams } from '../utils/AppConfigContext';

const AppFooter = () => {
  const params = useClientParams();
  const { lang } = useLanguage(translations);

  return (
    <footer className="footer-container">
      <div className="footer-content">
        <Space direction="horizontal" size="middle">
          {!params.MARKETING_MODE && <Link to="/blog">Blog</Link>}
          <Link to="/about">{lang('aboutUs')}</Link>
          <Link to="/termsofservice">{lang('termsOfService')}</Link>
          <Link to="/privacypolicy">{lang('privacyPolicy')}</Link>
        </Space>
      </div>
      <div className="disclosure">{lang('disclosure')}</div>
    </footer>
  );
};

export default AppFooter;
